import wrapElements from './wrap-elements';

export default function vWrap(elements, rect) {
    return wrapElements(elements, rect, "y", "x", "height");
}